import React, { useState, useEffect } from "react";
import "./About.css";

// Importa tu foto y las imágenes de la galería
import profilePhoto from "../../assets/about/profile.png";
import gallery1 from "../../assets/about/gallery1.png";
import gallery2 from "../../assets/about/gallery2.png";
import gallery3 from "../../assets/about/gallery3.png";
import gallery4 from "../../assets/about/gallery4.png";
import gallery5 from "../../assets/about/gallery5.png";

const words = ["engineer", "designer", "researcher", "Artist", "problem solver"];

export default function About() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        // Escribiendo
        if (displayText.length < currentWord.length) {
          setDisplayText(currentWord.slice(0, displayText.length + 1));
        } else {
          // Esperar antes de borrar
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        // Borrando
        if (displayText.length > 0) {
          setDisplayText(currentWord.slice(0, displayText.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentWordIndex((prev) => (prev + 1) % words.length);
        }
      }
    }, isDeleting ? 80 : 120); // Más rápido al borrar

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentWordIndex]);

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about__hero">
        <div className="about__photo">
          <img src={profilePhoto} alt="Judith Matute" />
        </div>

        <div className="about__content">
          <h1 className="about__title">
            Hello! I am{" "}
            <span className="highlight-pink">
              {displayText}
              <span className="typing-cursor">|</span>
            </span>
          </h1>

          <p className="about__text">
            I learned to navigate naturally between the creative and the logical
            because to me, they were never in conflict.
          </p>

          <p className="about__text">
            I am <strong>Engineer in Digital Entertainment Design from Universidad Pontificia
            Bolivariana, Medellín, Colombia.</strong> This is a discipline centered on the
            production of video games, animation, and interactive experiences. This
            foundation strengthened both my analytical thinking for solving complex
            problems and my ability to use creativity as a tool for innovation.
          </p>

          <p className="about__text">
            Later, I discovered something that cut across all these disciplines: the user
            experience. The uncertainty of what I might uncover during interviews and
            validations with users genuinely excited me. That curiosity led me into the
            field of <strong>User Experience Design</strong>, where I have been able to combine
            purposeful design with a deep interest in <strong>human behavior and research</strong>.
          </p>

          <p className="about__text">
            Today, I want to expand the role of design into spaces where it can drive
            meaningful social impact. I am particularly passionate about web
            accessibility, ensuring <strong>equitable access to information and technology for
            low-income communities, and advancing financial inclusion</strong>. My goal is
            to use design as a bridge to create solutions that are both <strong>innovative and
            socially transformative</strong>.
          </p>


       <a
      
            href="/cv_judithmatute.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="about__resume-btn"
          >
            View resume <span className="arrow">↗</span>
          </a>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="about__gallery">
        <div className="about__gallery-container">
          <div className="gallery__col-left">
            <img src={gallery1} alt="Gallery 1" />
          </div>

          <div className="gallery__col-center">
            <div className="gallery__row">
              <img src={gallery2} alt="Gallery 2" />
            </div>
            <div className="gallery__row">
              <img src={gallery4} alt="Gallery 4" />
            </div>
          </div>

          <div className="gallery__col-right">
            <div className="gallery__row">
              <img src={gallery3} alt="Gallery 3" />
            </div>
            <div className="gallery__row">
              <img src={gallery5} alt="Gallery 5" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}